import { render, staticRenderFns } from "./DeviceAvailabilityLabel.vue?vue&type=template&id=a7e5964e&scoped=true&"
import script from "./DeviceAvailabilityLabel.vue?vue&type=script&lang=js&"
export * from "./DeviceAvailabilityLabel.vue?vue&type=script&lang=js&"
import style0 from "./DeviceAvailabilityLabel.vue?vue&type=style&index=0&id=a7e5964e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7e5964e",
  null
  
)

export default component.exports